import { useQuery, useQueryClient } from 'react-query'

import { Repository } from '@/services/repository'

export const useGetCallDetails = (callId?: string | number) => {
  const queryClient = useQueryClient()

  const query = useQuery(
    ['useGetCallDetails', { callId: Number(callId) }],
    async () => {
      if (callId) {
        const call = await Repository.Entity.Call.FindById({
          callId: Number(callId),
        })
        const callTech = await Repository.Entity.CallTech.FindById({
          callId: Number(callId),
        })

        return {
          call,
          callTech: callTech.CallTechUserReport,
        }
      }
    },
  )

  function invalidateCallDetails() {
    queryClient.invalidateQueries(['useGetCallDetails', { callId }])
  }

  return { query, invalidateCallDetails }
}
